import { render } from "./FollowButton.vue.js?vue&type=template&id=45975790!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FollowButton.vue?vue&type=template&id=45975790"
import script from "./FollowButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FollowButton.vue?vue&type=script&lang=js"
export * from "./FollowButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FollowButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/follower-card/FollowButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45975790"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45975790', __exports__)) {
    api.reload('45975790', __exports__)
  }
  
  module.hot.accept("./FollowButton.vue.js?vue&type=template&id=45975790!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FollowButton.vue?vue&type=template&id=45975790", () => {
    api.rerender('45975790', render)
  })

}


export default __exports__